import { apiClient } from '@/api/client'

export type SyncTicket = {
  ticket: string
  expires_in: number
}

/**
 * SSE（/sync/events）購読用の使い捨てチケットを取得する
 * EventSource は Authorization ヘッダを送れないため、アクセストークンの代わりにクエリへ載せる
 */
export const issueSyncTicket = async (): Promise<SyncTicket> => {
  const res = await apiClient.post<SyncTicket>('/sync/ticket')
  return res.data
}
